import { useState } from "react";
import { TextAa, EnvelopeSimple } from "@phosphor-icons/react";
import { SectionShell } from "../../styleguide/Primitives";
import { Showcase, StateLabel } from "../LibraryPrimitives";
import { BloomInput } from "../../styleguide/ui/BloomInput";
import { SearchInput, Select, Chip, FilterBar } from "../inputs";

export function InputsSection() {
  const [chips, setChips] = useState(["Maths", "Year 3", "Stars"]);
  const [picked, setPicked] = useState("Stories");

  return (
    <SectionShell
      id="inputs"
      eyebrow="Inputs"
      eyebrowIcon={TextAa}
      title="Friendly fields, gentle errors"
      description="Inputs are tall and rounded with a soft fill that brightens on focus. Errors guide rather than scold, always in kind, plain language."
    >
      <div className="space-y-5">
        <div className="grid gap-5 lg:grid-cols-2">
          <Showcase title="Search & select">
            <div className="space-y-5">
              <SearchInput />
              <Select label="Choose a subject" options={["Maths", "English", "Reading", "Science"]} defaultValue="Reading" />
            </div>
          </Showcase>

          <Showcase title="Text input states">
            <div className="space-y-5">
              <div><StateLabel>Empty</StateLabel><BloomInput placeholder="Type your answer…" /></div>
              <div><StateLabel>With helper</StateLabel><BloomInput label="Class code" placeholder="BLOOM-123" helper="Ask your teacher for this code." /></div>
              <div><StateLabel>Error</StateLabel><BloomInput icon={EnvelopeSimple} placeholder="parent@email.com" error="Hmm, that doesn't look like an email yet." /></div>
            </div>
          </Showcase>
        </div>

        <Showcase title="Filters">
          <FilterBar />
        </Showcase>

        <Showcase title="Chips" description="Selectable & removable" tone="muted">
          <div className="space-y-4">
            <div className="flex flex-wrap gap-2">
              {["Stories", "Numbers", "Science", "Art"].map((c) => (
                <Chip key={c} selected={picked === c} onClick={() => setPicked(c)}>{c}</Chip>
              ))}
            </div>
            <div className="flex flex-wrap gap-2">
              {chips.map((c) => (
                <Chip key={c} onRemove={() => setChips((p) => p.filter((x) => x !== c))}>{c}</Chip>
              ))}
              {chips.length === 0 && <p className="text-sm font-semibold text-muted-foreground">All cleared — tap a chip above to add more.</p>}
            </div>
          </div>
        </Showcase>
      </div>
    </SectionShell>
  );
}

export default InputsSection;
